import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-base-send-mail',
  templateUrl: './base-send-mail.component.html',
  styleUrl: './base-send-mail.component.scss'
})
export class BaseSendMailComponent {
  editId;
  systemMenuId;

  // constructor
  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    this.editId = data.id;
    this.systemMenuId = data.systemMenuId;
  }

  ngOnInit(): void {
  }

  send() {

  }

  newMailEnter = false;

  onClick() {
    this.newMailEnter = !this.newMailEnter;
  }
  
}
